<template>
  <div>
    <div class="uk-text-bolder">{{label}}</div>
  <div class="uk-grid uk-margin-remove-top">
        <div class="uk-width-1-2 uk-margin-remove-top uk-flex uk-flex-column uk-text-left">
          <label for="addrLine1" class="uk-form-label">Street Address {{requiredLabel}}</label>

          <input
            v-model="address.streetAddress"
            type="text"
            id="addrLine1"
            class="uk-input "
            v-bind:class="{ 'uk-form-danger': textDanger }"
          />
        </div>

        <div class="uk-width-1-2 uk-margin-remove-top uk-flex uk-flex-column uk-text-left ">
          <label for="addrLine2" class="uk-form-label">Address line 2</label>

          <input
            v-model="address.suite"
            type="text"
            id="addrLine2"
            class="uk-input"
            v-bind:class="{ 'uk-form-danger': textDanger }"
          />
        </div>
  </div>
  <div class="uk-grid uk-margin-remove-top">
        <div class="uk-width-1-3 uk-flex uk-flex-column uk-text-left ">
          <label for="addrCity" class="uk-form-label">City {{requiredLabel}}</label>

          <input
            v-model="address.city"
            type="text"
            id="addrCity"
            class="uk-input uk-form-width-medium uk-width-1-1"
            v-bind:class="{ 'uk-form-danger': textDanger }"
          />
        </div>

        <div class="uk-width-1-3 uk-flex uk-flex-column uk-text-left ">
          <label for="addrState" class="uk-form-label">State {{requiredLabel}}</label>

          <input
            v-model="address.state"
            type="text"
            id="addrState"
            class="uk-input uk-form-width-medium uk-width-1-1"
            v-bind:class="{ 'uk-form-danger': textDanger }"
          />
        </div>
        <div class="uk-width-1-3 uk-flex uk-flex-column uk-text-left ">
          <label for="addrZip" class="uk-form-label">Zip {{requiredLabel}}</label>

          <input
            v-model="address.zipCode"
            type="text"
            id="addrZip"
            class="uk-input uk-form-width-medium uk-width-1-1"
            v-bind:class="{ 'uk-form-danger': textDanger }"
          />
        </div>
  </div>
  <br />
  </div>
</template>
<script lang="ts">
import { PropType, defineComponent } from 'vue';

import { Address } from '../../types';

export default defineComponent({
  name: 'AddressInputBlock',
  props: {
    label: String,
    requiredLabel: {
      type: String,
      default: '',
    },
    address: {
      type: Object as PropType<Address>,
      default: {},
    },
  },
  data() {
    return {
      textDanger: false,
    };
  },
});
</script>
